import {request} from './request';

const maintenanceTime = () => {
    return request({
        url: '/public/maintenance',
        method: 'GET'
    });
};

const configAPI = {maintenanceTime};

export default configAPI


// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/configAPI.ts